var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{ [`bg-${_vm.type}`]: _vm.type }},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"header-body"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }